import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import {ActivatedRoute} from '@angular/router';
import { Platform } from '@ionic/angular';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import {BaseModal} from '../../../../model/base';
import {WebParameterContext} from '../../../../model/common';
import { BaseCase } from '../../../basecase';
import { MzGridListInterimplanComponent } from "../mz-grid-list-interimplan/mz-grid-list-interimplan.component";
import { CommonService } from '../../../../service/common.service';
declare var app;
@Component({
  selector: 'app-mz-grid-list-temporary-plan',
  templateUrl: './mz-grid-list-temporary-plan.component.html',
  styleUrls: ['./mz-grid-list-temporary-plan.component.scss']
})
export class MzGridListTemporaryPlanComponent extends GridBaseCase {
  searchType:number = 0;//搜索类型(门店，分类，地图)
  searchTypeNum:number = 0;//分类筛选（分类筛选中按门店、按人员、按渠道）
  searchTypemendian:number = 0;//门店/经销商
  qudaoNumber:number = null;//渠道
  personNumber:number = null;//人员
  searchVal:string = '';//输入搜索值
  chage:any;
  dataChannelArrayList = [];//获取渠道结果值
  dataPersonArrayList = [];//获取人员结果值

  @ViewChild('child') myChild:MzGridListInterimplanComponent;
  constructor( 
    private platform:Platform,
    private activaRouter: ActivatedRoute,
    private map:MapclientServiceService,
    private msg:MessageclientService,
    private http: HttpCustomerService,
    public base:BaseModal,
    public baseService:BaseCase,
    public com:CommonService
    ) { super(); }
  ngOnInit() {
    // this.location();
  }
EventLink(element,item){
    if(item.isCheck){
      item.isCheck = false;
    }else{
      item.isCheck = true;
    }
  }

  searchChange($event,type:any = "other"){
    // console.log(this.baseService.storeSearch,$event);
    if($event.keyCode == 13 || type == 'search'){
      this.myChild.LoadData(1);
    }
  }
  cancalEvent(){
    this.searchType = 0;
    // delete  this.baseService.storeSearch.searchType;
    // delete this.baseService.storeSearch.Name;
    // this.myChild.LoadData(1);
  }
  getMapsEvent(ev){//返回附近门店信息列表
      console.log(ev);
      this.baseService.ListData=[];
     this.baseService.ListData = ev;
      // this.myChild.loadingchileData(ev);
    //this.dataChannelArrayList = ev;
   
  }

    /**
* 下拉刷新数据
* @param event
*/
doRefresh(event) {
  this.myChild.LoadData(1);
  console.log("下拉刷新");
  event.target.complete();
}

  comfireEvent(){
    this.searchType = 0;
    this.myChild.LoadData(1);
  }
  /**
   * 
   * @param n 搜索类型类型
   */
  search(n:number):void{
    // this.searchType == n ? this.searchType = 0 : this.searchType = n;
    if(this.searchType == n){
      this.searchType = 0;
      this.baseService.storeSearch.searchType = 0;
    }else{
      this.searchType = n;
      this.baseService.storeSearch.searchType = n;
    }
    if(n==3){//表示地图,防止下拉刷新操作
      localStorage.setItem("setMap","true");
    }else{
      localStorage.removeItem("setMap");
    }

  }
  //类型
  searchEvent(n:number):void{
    // if(this.searchTypeNum == n){
    //   this.searchTypeNum = 0;
    // }else{
    //   this.searchTypeNum = n;
    // }
    this.searchTypeNum = n;
    if( this.searchTypeNum ==1 && this.dataPersonArrayList.length == 0){//表示人员
      this.bindLoadPersonData();
    }
    if( this.searchTypeNum ==2 && this.dataChannelArrayList.length == 0){//表示渠道
        this.bindLoadChannelData();
   }
  }
  //门店经销商
  Eventserch(n:number):void{
     if(this.searchTypemendian == n){
       if(n!=1)
      this.searchTypemendian = 0;
    }else{
      this.searchTypemendian = n;
    }
    this.baseService.storeSearch.ObjectType =n+1;//门店、经销商
  }

  //人员
  EventserchPerson(n:number):void{
    if(this.personNumber == n){
      this.personNumber = null;
    }else{
      this.personNumber = n;
    }
    if(this.personNumber == null){
      this.baseService.storeSearch.userId = null;//人员
    }else{
      let a_ID = this.dataPersonArrayList[n]["ID"];
      this.baseService.storeSearch.userId = a_ID;//人员
    }
    
  }

  //渠道
  Eventserchqudao(n:number):void{
    if(this.qudaoNumber == n){
      this.qudaoNumber = null;
    }else{
      this.qudaoNumber = n;
    }
    
    if(this.qudaoNumber == null){
      this.baseService.storeSearch.FK_TBStoreChannel_ID = null;//渠道
    }else{
      let a_ID = this.dataChannelArrayList[n]["a_ID"];
      this.baseService.storeSearch.FK_TBStoreChannel_ID = a_ID;//渠道
    }
  }

  /**
   * 渠道数据
   */
  bindLoadChannelData(){
    let that = this;
    // that.loading = false;
    // that.apiObj['status'] = false;
    // that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    // if (that.element.selectItemList.gridViewConfigName) {
    //   body.ConfigName = that.element.selectItemList.gridViewConfigName;
    // } 
    body.ConfigName ="TBStoreChannelXML";//获取对应的渠道数据
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // if(!that.com.GetAccount.IsAdmin){
    //   console.log(that.baseService.storeSearch.name);
    //   if(that.baseService.storeSearch.name){
    //     body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ObjectName":that.baseService.storeSearch.name});
    //   }else{
    //     body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id});
    //   }
    // }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.dataChannelArrayList = [];
      // setTimeout(function () {
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      //   that.loading = true;
      // });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          //  console.log(item);
          that.dataChannelArrayList.push(item);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
      }
      
    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      console.log(error);
    })

  }

  /**
   * 人员数据
   */
  bindLoadPersonData(){
    let that = this;
    // that.loading = false;
    // that.apiObj['status'] = false;
    // that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    // if (that.element.selectItemList.gridViewConfigName) {
    //   body.ConfigName = that.element.selectItemList.gridViewConfigName;
    // } 
    body.ConfigName ="UserApproverInfo";//获取对应的经销商,门店数据
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = 10;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody= JSON.stringify({"userId":that.com.GetAccount.Id,"type":2});
    that.http.post(app.DEFAULTURL, body).then(data => {
      // that.dataPersonArrayList = [{'userId':that.com.GetAccount.Id,'ChineseName':that.com.GetAccount.DisplayName}];
      that.dataPersonArrayList = [];
      // setTimeout(function () {
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      //   that.loading = true;
      // });
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          //  console.log(item);
          that.dataPersonArrayList.push(item);
        });
      }
      
    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      console.log(error);
    })

  }
}
